import { useState, useCallback } from 'react'

export enum ContentSteps {
    FIRST = 'FIRST',
    SECOND = 'SECOND',
}

const stepFlow: Record<ContentSteps, ContentSteps | null> = {
    [ContentSteps.FIRST]: ContentSteps.SECOND,
    [ContentSteps.SECOND]: null,
}

export const useStepFlow = () => {
    const [step, setStep] = useState<ContentSteps>(ContentSteps.FIRST)

    const goToNextStep = useCallback((currentStep: ContentSteps) => {
        const nextStep = stepFlow[currentStep]
        if (nextStep) {
            setStep(nextStep)
        } else {
            console.warn('Последний шаг, переход невозможен')
        }
    }, [])

    return { step, goToNextStep }
}
